import { loadStripe } from '@stripe/stripe-js';

const stripePublicKey =
  process.env.REACT_APP_STRIPE_PUBLIC_KEY ||
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

export const stripePromise = stripePublicKey
  ? loadStripe(stripePublicKey)
  : Promise.resolve(null);

export const getStripe = async () => {
  const stripe = await stripePromise;
  if (!stripe) {
    throw new Error('Stripe is not configured. Missing REACT_APP_STRIPE_PUBLIC_KEY.');
  }
  return stripe;
};
